import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BrandingPanel = () => {
  const certifications = [
  {
    id: 1,
    name: 'ISO 9001:2015',
    description: 'Gestão da Qualidade',
    icon: 'Award',
    verified: true
  },
  {
    id: 2,
    name: 'CNPJ Ativo',
    description: 'Receita Federal',
    icon: 'CheckCircle',
    verified: true
  },
  {
    id: 3,
    name: 'Certificação ABNT',
    description: 'Normas Técnicas',
    icon: 'Shield',
    verified: true
  }];


  const testimonials = [
  {
    id: 1,
    name: 'Maria Silva',
    company: 'TechCorp Brasil',
    role: 'Diretora de TI',
    content: `O ConsultFlow revolucionou nossa gestão de projetos. A visibilidade em tempo real e o controle de ordens de serviço aumentaram nossa eficiência em 40%.`,
    avatar: "https://images.unsplash.com/photo-1734456611474-13245d164868",
    avatarAlt: 'Professional headshot of Brazilian businesswoman with shoulder-length dark hair wearing navy blazer'
  },
  {
    id: 2,
    name: 'Carlos Mendes',
    company: 'Indústrias ABC',
    role: 'Gerente de Operações',
    content: `A interface mobile para técnicos é excepcional. Nossos profissionais em campo conseguem atualizar status e registrar atividades de forma intuitiva.`,
    avatar: "https://images.unsplash.com/photo-1735181094336-7fa757df9622",
    avatarAlt: 'Professional headshot of middle-aged Brazilian businessman with short gray hair in dark suit'
  }];


  const stats = [
  { label: 'Projetos Gerenciados', value: '2.500+', icon: 'FolderOpen' },
  { label: 'Técnicos Ativos', value: '850+', icon: 'Users' },
  { label: 'Clientes Satisfeitos', value: '98%', icon: 'ThumbsUp' },
  { label: 'Uptime do Sistema', value: '99.9%', icon: 'Activity' }];


  return (
    <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground p-8 flex-col justify-between">
      {/* Header */}
      <div>
        <div className="flex items-center space-x-3 mb-8">
          <div className="w-12 h-12 bg-primary-foreground/20 rounded-lg flex items-center justify-center">
            <Icon name="Briefcase" size={28} color="white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">ConsultFlow</h2>
            <p className="text-primary-foreground/80 font-medium">Pro</p>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-semibold mb-3">
            Gestão Completa de Consultorias
          </h3>
          <p className="text-primary-foreground/90 leading-relaxed">
            Plataforma integrada para controle de projetos, ordens de serviço e atendimento ao cliente. 
            Desenvolvida especialmente para empresas de consultoria brasileiras.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          {stats?.map((stat) =>
          <div key={stat?.label} className="bg-primary-foreground/10 rounded-lg p-4">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name={stat?.icon} size={16} className="text-primary-foreground/80" />
                <span className="text-sm text-primary-foreground/80">{stat?.label}</span>
              </div>
              <p className="text-lg font-bold">{stat?.value}</p>
            </div>
          )}
        </div>
      </div>
      {/* Certifications */}
      <div className="mb-8">
        <h4 className="font-semibold mb-4 flex items-center">
          <Icon name="Award" size={18} className="mr-2" />
          Certificações e Conformidade
        </h4>
        <div className="space-y-3">
          {certifications?.map((cert) =>
          <div key={cert?.id} className="flex items-center space-x-3 bg-primary-foreground/10 rounded-lg p-3">
              <Icon name={cert?.icon} size={16} className="text-success" />
              <div className="flex-1">
                <p className="font-medium text-sm">{cert?.name}</p>
                <p className="text-xs text-primary-foreground/80">{cert?.description}</p>
              </div>
              {cert?.verified &&
            <Icon name="CheckCircle" size={16} className="text-success" />
            }
            </div>
          )}
        </div>
      </div>
      {/* Testimonials */}
      <div>
        <h4 className="font-semibold mb-4 flex items-center">
          <Icon name="MessageSquare" size={18} className="mr-2" />
          Depoimentos de Clientes
        </h4>
        <div className="space-y-4">
          {testimonials?.map((testimonial) =>
          <div key={testimonial?.id} className="bg-primary-foreground/10 rounded-lg p-4">
              <p className="text-sm text-primary-foreground/90 mb-3 italic">
                "{testimonial?.content}"
              </p>
              <div className="flex items-center space-x-3">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-8 h-8 rounded-full object-cover" />

                <div>
                  <p className="font-medium text-sm">{testimonial?.name}</p>
                  <p className="text-xs text-primary-foreground/80">
                    {testimonial?.role} - {testimonial?.company}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Footer */}
      <div className="mt-8 pt-6 border-t border-primary-foreground/20">
        <div className="flex items-center justify-between text-sm text-primary-foreground/80">
          <p>© {new Date()?.getFullYear()} ConsultFlow Pro</p>
          <div className="flex items-center space-x-4">
            <span className="flex items-center">
              <Icon name="Shield" size={14} className="mr-1" />
              Seguro
            </span>
            <span className="flex items-center">
              <Icon name="Lock" size={14} className="mr-1" />
              Criptografado
            </span>
          </div>
        </div>
      </div>
    </div>);

};

export default BrandingPanel;